import React from 'react';
import { connect } from 'react-redux';

import { Button } from '~/eds/src/components/Button/Button';
import { useIntl } from 'react-intl';
import Box from '~/ui/components/Box/Box';
import FlexLayout from '~/ui/components/FlexLayout/FlexLayout';

import FieldAssignmentMenu from '../FieldAssignmentMenu/FieldAssignmentMenu';
import ConditionalTextFieldSection from './ConditionalTextFieldSection';
import ContractFieldSection from './ContractFieldSection';
import PartySignerFieldSection from './PartySignerFieldSection';
import UnassignedFieldSection from './UnassignedFieldSection';
import WssFieldSection from './WssFieldSection';

function Fields({
  // connected
  disabled,
  isWssDesignated,
}) {
  const intl = useIntl();
  return (
    <FlexLayout flexDirection="column" sx={{ minHeight: 0 }}>
      {disabled ? null : (
        <Box px={10} py={3} sx={{ borderBottom: 'border' }}>
          <FieldAssignmentMenu
            trigger={
              <Button
                id="workflow-sidebar--add-field-button"
                isFullWidth
                text={intl.formatMessage({
                  id: 'WorkflowBuilderPage.Sidebar.Fields.addFieldButton',
                  defaultMessage: 'Add Field',
                  description:
                    'Button in the workflow sidebar to add a new field to the document',
                })}
                variant="secondary"
              />
            }
          />
        </Box>
      )}
      <FlexLayout flexDirection="column" sx={{ overflow: 'auto' }}>
        <UnassignedFieldSection />
        {isWssDesignated && <WssFieldSection />}
        <ContractFieldSection />
        <PartySignerFieldSection />
        <ConditionalTextFieldSection />
      </FlexLayout>
    </FlexLayout>
  );
}

function mapStateToProps({ builder, workflow }) {
  return {
    disabled: !builder.shouldEnableAllComponents,
    isWssDesignated: workflow.wssDesignated,
  };
}

export default connect(mapStateToProps)(Fields);
